import * as yup from 'yup';
import { FullBleedSliderHero } from '@web/components';
import { carouselConfigSchema } from '../schemas';
import { schema as heroSlideSchema } from './hero_slide';

export const component = FullBleedSliderHero;

export const schema = yup
  .object({
    slides: yup.array(heroSlideSchema).min(1).required(),
    carouselConfig: yup.object().nullable(),
  })
  .transform(value => {
    const carouselBlock = value.carousel_config?.[0];
    return {
      slides: value.slides ?? [],
      carouselConfig: carouselBlock?.as_carousel
        ? carouselConfigSchema.cast(carouselBlock)
        : null,
    };
  });
